export default __webpack_public_path__ + "static/media/provider-logo.9b66a8cb.png";